// controllers/submenu_panel_controller.js
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  responsiveSubmenu = this.element.closest('responsive-submenu')

  close() {
    this.responsiveSubmenu.removeAttribute('is-open')
    this.sendClose()
  }

  sendClose() {
    this.dispatch("close", {
      prefix: "submenu",
      target: window,
      detail: { id: this.responsiveSubmenu.dataset.submenuId }
    })
  }
}
